
export const strongTranslationsEN = {
  "G11": {
    m: "Abraham",
    d: "The patriarch Abraham, father of believers.",
    u: "Used 73 times in the NT. Model of faith.",
    e: "From Hebrew אַבְרָהָם (Abraham) = father of a multitude"
  },
  "G25": {
    m: "to love with divine, unconditional love",
    d: "To love with selfless, sacrificial, and divine love. The love of God for humanity and the love we should have for one another.",
    u: "Used 143 times in the NT. Describes divine, perfect, and unconditional love.",
    e: "From ἄγω (ago) = to lead, guide toward good"
  },
  "G26": {
    m: "divine love, charity",
    d: "The perfect love of God; brotherly love, affection, goodwill, charity. The love that unites God and man, and man to his neighbor.",
    u: "Used 116 times in the NT. The central word of Christianity to describe divine love.",
    e: "Derived from ἀγαπάω (agapao)"
  },
  "G27": {
    m: "beloved, dear",
    d: "Loved, cherished; beloved of God or men.",
    u: "Used 61 times in the NT. The beloved Son of God.",
    e: "From ἀγαπάω (agapao) = to love"
  },
  "G32": {
    m: "angel, messenger",
    d: "Messenger; heavenly angel in God's service.",
    u: "Used 175 times in the NT. The angels of God.",
    e: "From ἀγγέλλω (aggello) = to announce"
  },
  "G36": {
    m: "of low birth, ignoble",
    d: "Without nobility, of low extraction; despised.",
    u: "Used 1 time in the NT (1 Cor 1:28).",
    e: "From ἀ- (negative) + γένος (genos) = birth"
  },
  "G93": {
    m: "injustice, unrighteousness",
    d: "Violation of right, injustice; wickedness, moral iniquity.",
    u: "Used 25 times in the NT. Opposite of δικαιοσύνη (righteousness).",
    e: "From ἀ- (negative) + δίκη (dike) = justice"
  },
  "G154": {
    m: "to ask, request, beg",
    d: "To ask, request something, beg, petition. Humble and respectful request.",
    u: "Used 70 times in the NT. Request addressed to God or men.",
    e: "From αἰτέω (aiteo) primitive root; to ask"
  },
  "G166": {
    m: "eternal, everlasting",
    d: "Without beginning or end, existing always; in the NT, often linked to eternal life in God.",
    u: "Used 71 times in the NT. Often qualifies eternal life and the kingdom of God.",
    e: "From αἰών (aion) = age, era, eternity"
  },
  "G225": {
    m: "truth, reality",
    d: "That which is true concerning God and the duties of man; divine truth revealed.",
    u: "Used 109 times in the NT. Central concept of Jesus' teaching.",
    e: "From ἀληθής (alethes) = true, sincere"
  },
  "G281": {
    m: "amen, truly",
    d: "Formula of affirmation: so be it, truly, certainly.",
    u: "Used 129 times in the NT. Jesus says 'Truly, truly'.",
    e: "From Hebrew אָמֵן (amen) = firm, faithful"
  },
  "G444": {
    m: "man, human being",
    d: "Human being, man or woman; humanity in general.",
    u: "Used 550 times in the NT. Man created in God's image.",
    e: "From ἀνήρ (aner) = man and ὤψ (ops) = face"
  },
  "G622": {
    m: "to lose, destroy, perish",
    d: "To destroy completely; to lose, perish; to be ruined.",
    u: "Used 90 times in the NT. To save what was lost.",
    e: "From ἀπό (apo) = from + ὄλλυμι (ollumi) = to destroy"
  },
  "G649": {
    m: "to send, delegate",
    d: "To send with a mission; to delegate as ambassador.",
    u: "Used 132 times in the NT. The Father sends the Son.",
    e: "From ἀπό (apo) = from + στέλλω (stello) = to send"
  },
  "G721": {
    m: "lamb",
    d: "Little lamb; designates Jesus Christ as the Lamb of God.",
    u: "Used 30 times in the NT, especially in Revelation.",
    e: "Diminutive of ἀρήν (aren) = lamb"
  },
  "G730": {
    m: "male, masculine",
    d: "Of male sex, male.",
    u: "Used 9 times in the NT. God created man male and female.",
    e: "Primary root"
  },
  "G740": {
    m: "bread, loaf",
    d: "Bread, food; the bread of life = Christ.",
    u: "Used 97 times in the NT. Jesus the bread of life.",
    e: "From ἄρω (aro) = to lift, raise"
  },
  "G746": {
    m: "beginning, origin",
    d: "The beginning, origin, first principle. In John 1:1-2, designates the eternal beginning where the Word (Logos) already existed.",
    u: "Used 55 times in the NT. Key word of John 1:1 'In the beginning was the Word'.",
    e: "Primary word; beginning, first origin"
  },
  "G772": {
    m: "weak, sick",
    d: "Without strength, weak; sick, infirm; spiritually weak.",
    u: "Used 25 times in the NT. God chooses the weak of the world.",
    e: "From ἀ- (negative) + σθένος (sthenos) = strength"
  },
  "G907": {
    m: "to baptize, immerse",
    d: "To immerse in water; to baptize to purify or initiate.",
    u: "Used 77 times in the NT. Christian baptism.",
    e: "From βάπτω (bapto) = to dip, immerse"
  },
  "G1080": {
    m: "to beget, bring forth",
    d: "To beget, give birth; to be born again spiritually.",
    u: "Used 97 times in the NT. To be born of God, born again.",
    e: "Primary root"
  },
  "G1096": {
    m: "to become, to happen, to come to pass",
    d: "To become, come into existence, happen, take place, occur.",
    u: "Used 678 times in the NT. 'All things were made through him' (John 1:3).",
    e: "From γίνομαι (ginomai) = to become"
  },
  "G1097": {
    m: "to know, understand, perceive",
    d: "To know by personal experience; to understand, perceive, be aware of.",
    u: "Used 222 times in the NT. Experiential knowledge, not merely intellectual.",
    e: "Indo-European root *gen- = to beget, know"
  },
  "G1100": {
    m: "tongue, language",
    d: "Organ of speech; language, dialect; gift of tongues.",
    u: "Used 50 times in the NT. The gift of tongues.",
    e: "Primary root"
  },
  "G1166": {
    m: "to show, demonstrate",
    d: "To expose to view, show; to prove, demonstrate.",
    u: "Used 33 times in the NT. God shows His glory.",
    e: "Primary root"
  },
  "G1208": {
    m: "second",
    d: "The second in a series or order.",
    u: "Used 44 times in the NT. The second commandment.",
    e: "From δύο (duo) = two"
  },
  "G1271": {
    m: "understanding, mind",
    d: "The faculty of thinking, hearing, understanding; mind, comprehension.",
    u: "Used 12 times in the NT. The mind renewed by Christ.",
    e: "From διά (dia) = through + νοῦς (nous) = mind"
  },
  "G1320": {
    m: "teacher, master, instructor",
    d: "Teacher, instructor; one who teaches religious truths.",
    u: "Used 59 times in the NT. 'Rabbi, we know you are a teacher come from God' (John 3:2).",
    e: "From διδάσκω (didasko) = to teach"
  },
  "G1325": {
    m: "to give, grant",
    d: "To give something to someone; to grant, permit; to deliver.",
    u: "Used 415 times in the NT. God gives generously.",
    e: "Primary root"
  },
  "G1372": {
    m: "to thirst, desire earnestly",
    d: "To suffer from thirst; to desire earnestly, aspire to.",
    u: "Used 16 times in the NT. Spiritual thirst for God.",
    e: "From δίψα (dipsa) = thirst"
  },
  "G1401": {
    m: "slave, servant",
    d: "Slave, servant; voluntary servant of God.",
    u: "Used 124 times in the NT. Servants of Christ.",
    e: "From δέω (deo) = to bind"
  },
  "G1411": {
    m: "power, strength, miracle",
    d: "Force, power, ability; act of power, miracle.",
    u: "Used 120 times in the NT. The power of God, of the Holy Spirit.",
    e: "From δύναμαι (dunamai) = to be able"
  },
  "G1417": {
    m: "two",
    d: "The number two; a pair.",
    u: "Used 135 times in the NT. Two or three witnesses.",
    e: "Primary root"
  },
  "G1473": {
    m: "I, me",
    d: "Personal pronoun of the first person singular.",
    u: "Used 2567 times in the NT. Very frequent.",
    e: "Primary pronoun"
  },
  "G1484": {
    m: "nation, people, Gentiles",
    d: "People, nation; the pagan nations (non-Jews).",
    u: "Used 162 times in the NT. The gospel for all nations.",
    e: "Primary root"
  },
  "G1492": {
    m: "to know, see, understand",
    d: "To know by perception, see, understand, realize. Knowledge gained through experience or revelation.",
    u: "Used 666 times in the NT. Fundamental verb of knowledge in John's Gospel.",
    e: "Perfect form of εἴδω (eido); to see, know"
  },
  "G1510": {
    m: "to be, exist",
    d: "Verb to be in all its senses; to exist, remain, take place.",
    u: "Most used verb in the NT (2460+ times).",
    e: "Primary root"
  },
  "G1515": {
    m: "peace",
    d: "State of tranquility; peace with God; harmony between people.",
    u: "Used 92 times in the NT. The peace of Christ.",
    e: "From εἴρω (eiro) = to join, bind"
  },
  "G1520": {
    m: "one, single",
    d: "One only; unique, only; a certain.",
    u: "Used 344 times in the NT. The unity of God, the united church.",
    e: "Primary root"
  },
  "G1586": {
    m: "to choose, elect",
    d: "To choose for oneself, select; to elect by divine grace.",
    u: "Used 21 times in the NT. God elects His children.",
    e: "From ἐκ (ek) = out of + λέγω (lego) = to choose"
  },
  "G1658": {
    m: "free, freed",
    d: "Free, not a slave; freed from slavery of sin.",
    u: "Used 23 times in the NT. Free in Christ.",
    e: "Probably from ἔρχομαι (erchomai) = to come"
  },
  "G1672": {
    m: "Greek, Gentile",
    d: "A Greek by birth or language; a non-Jew.",
    u: "Used 25 times in the NT. Neither Jew nor Greek in Christ.",
    e: "From Ἑλλάς (Hellas) = Greece"
  },
  "G1680": {
    m: "hope, confident expectation",
    d: "Expectation of good, hope founded on God; confidence in the future based on divine promises.",
    u: "Used 54 times in the NT. One of the three theological virtues with faith and love.",
    e: "From ἔλπω (elpo) = to wait, hope"
  },
  "G1743": {
    m: "to strengthen, make strong",
    d: "To make strong, strengthen; to give power.",
    u: "Used 8 times in the NT. God strengthens believers.",
    e: "From ἐν (en) = in + δυναμόω (dynamoo) = to make powerful"
  },
  "G1746": {
    m: "to clothe, dress",
    d: "To put on a garment; to clothe with a quality or power.",
    u: "Used 27 times in the NT. To put on Christ, put on the armor of God.",
    e: "From ἐν (en) = in + δύω (duo) = to enter, clothe"
  },
  "G1785": {
    m: "commandment, order",
    d: "An order, commandment, precept; especially a divine commandment.",
    u: "Used 67 times in the NT. The commandments of God and Christ.",
    e: "From ἐντέλλομαι (entellomai) = to command"
  },
  "G1848": {
    m: "to despise, treat with contempt",
    d: "To consider as nothing, despise; to treat with disdain.",
    u: "Used 11 times in the NT. The world despises what God chooses.",
    e: "From ἐξ (ex) = out of + οὐθείς (outheis) = nobody"
  },
  "G2041": {
    m: "work, labor, deed",
    d: "Work, toil; action, deed; work accomplished.",
    u: "Used 169 times in the NT. The works of God, good works.",
    e: "From ἔργω (ergo) = to work"
  },
  "G2048": {
    m: "desert, wilderness",
    d: "Desert place, wilderness; solitary, unpopulated.",
    u: "Used 48 times in the NT. Jesus' 40 days in the wilderness.",
    e: "From ἔρημος (eremos) = abandoned"
  },
  "G2065": {
    m: "to question, ask, inquire",
    d: "To question, ask, inquire for information. Inquiry or investigation.",
    u: "Used 63 times in the NT. Questioning to obtain answers.",
    e: "Uncertain root; to question, inquire"
  },
  "G2189": {
    m: "enmity, hostility",
    d: "Hatred, hostility, enmity.",
    u: "Used 6 times in the NT. Enmity with God abolished.",
    e: "From ἐχθρός (echthros) = enemy"
  },
  "G2205": {
    m: "zeal, jealousy, envy",
    d: "Passionate ardor; can be positive (zeal for God) or negative (jealousy, envy).",
    u: "Used 16 times in the NT. Can be virtuous or vicious depending on context.",
    e: "From ζέω (zeo) = to boil, be fervent"
  },
  "G2222": {
    m: "life",
    d: "Physical or spiritual life; eternal life in God.",
    u: "Used 135 times in the NT. Jesus is the life.",
    e: "From ζάω (zao) = to live"
  },
  "G2258": {
    m: "was, he was",
    d: "Was, he was, she was. Imperfect form of the verb to be (εἰμί). Expresses a state or existence in the past.",
    u: "Used 267 times in the NT. Crucial in John 1:1 'In the beginning was the Word'.",
    e: "Imperfect of εἰμί (eimi) = to be; was"
  },
  "G2296": {
    m: "wonder, marvel, admire",
    d: "To wonder, marvel, be amazed, admire. Reaction of astonishment to something extraordinary.",
    u: "Used 43 times in the NT. Frequent reaction to Jesus' miracles and teachings.",
    e: "From θαῦμα (thauma) = wonder; to marvel"
  },
  "G2316": {
    m: "God, deity",
    d: "The supreme Divinity - especially (with the article) the one true God. In Scripture, reveals the one God who manifests as Father, Son, and Holy Spirit, without division of the divine essence.",
    u: "Used 1343 times in the NT according to biblical sources. Central word designating the one true God.",
    e: "Of uncertain affinity according to Strong's. Designates a deity, particularly the supreme Divinity. Biblical usage: reveals the living God who acts in salvation history."
  },
  "G2338": {
    m: "female, feminine",
    d: "Of female sex, female.",
    u: "Used 5 times in the NT. Man and woman equal in Christ.",
    e: "From θηλάζω (thelazo) = to nurse"
  },
  "G2362": {
    m: "throne",
    d: "Royal seat, throne; royal power and authority.",
    u: "Used 62 times in the NT. The throne of God and the Lamb.",
    e: "Primary root"
  },
  "G2381": {
    m: "Thomas",
    d: "Thomas, proper name. One of the twelve apostles, also called Didymus (twin). Known for requesting proof of resurrection.",
    u: "Used 11 times in the NT. The apostle who doubted then believed.",
    e: "From Aramaic תְּאוֹמָא (teoma) = twin"
  },
  "G2398": {
    m: "own, particular, personal",
    d: "Own, particular, personal, private. What belongs properly to someone, distinct from others.",
    u: "Used 114 times in the NT. Concept of personal ownership and distinction.",
    e: "From uncertain root; own, particular"
  },
  "G2424": {
    m: "Jesus",
    d: "Jesus of Nazareth, the Messiah, the Savior.",
    u: "Used 917 times in the NT. The name above all names.",
    e: "From Hebrew יְהוֹשֻׁעַ (Yehoshua) = YHWH saves"
  },
  "G2453": {
    m: "Jew, Judean",
    d: "Belonging to the Jewish race; inhabitant of Judea.",
    u: "Used 195 times in the NT. The Jews, God's chosen people.",
    e: "From Ἰούδας (Ioudas) = Judah"
  },
  "G2491": {
    m: "John",
    d: "John, proper name. John the Baptist the forerunner, John the beloved apostle, author of Gospel and epistles.",
    u: "Used 135 times in the NT. Name of two major NT figures.",
    e: "From Hebrew יוֹחָנָן (Yochanan) = YHWH is gracious"
  },
  "G2531": {
    m: "as, according as",
    d: "As, in the same way as; according as, insofar as.",
    u: "Used 182 times in the NT. Comparative conjunction.",
    e: "From κατά (kata) = according to + ὡς (hos) = as"
  },
  "G2537": {
    m: "new, recent",
    d: "New in time or quality; fresh, recent, unused.",
    u: "Used 42 times in the NT. New creation, new commandment.",
    e: "Uncertain root"
  },
  "G2570": {
    m: "good, beautiful",
    d: "Good in nature, beautiful; honorable, excellent, virtuous.",
    u: "Used 100 times in the NT. The good shepherd, good works.",
    e: "Primary root"
  },
  "G2588": {
    m: "heart",
    d: "The physical heart; center of inner life, soul, spirit; thoughts and feelings.",
    u: "Used 156 times in the NT. Seat of spiritual life.",
    e: "Primary root"
  },
  "G2596": {
    m: "according to, against, through",
    d: "Preposition with several meanings: according to, in accordance with; against; through.",
    u: "Used over 470 times in the NT. Very frequent preposition.",
    e: "Primary preposition"
  },
  "G2617": {
    m: "to shame, dishonor",
    d: "To put to shame, dishonor; to confound, humiliate.",
    u: "Used 13 times in the NT. God confounds the wise of the world.",
    e: "From κατά (kata) = against + αἰσχύνω (aischuno) = to be ashamed"
  },
  "G2744": {
    m: "to boast, glory",
    d: "To boast, brag; to find one's pride in something.",
    u: "Used 37 times in the NT. To boast in the Lord.",
    e: "From καῦχος (kauchos) = boasting"
  },
  "G2889": {
    m: "world, universe, humanity",
    d: "The world order, the universe; fallen humanity; the system opposed to God.",
    u: "Used 186 times in the NT. Can designate creation or the sinful system.",
    e: "From κοσμέω (kosmeo) = to adorn, arrange"
  },
  "G2919": {
    m: "to judge, decide",
    d: "To judge, pronounce judgment; to decide, determine.",
    u: "Used 114 times in the NT. God judges the world.",
    e: "Primary root"
  },
  "G2920": {
    m: "judgment, justice, condemnation",
    d: "Judgment, justice, condemnation, judicial decision. God's judgment, just and perfect.",
    u: "Used 47 times in the NT. Central concept of divine justice.",
    e: "From κρίνω (krino) = to judge, decide"
  },
  "G2962": {
    m: "Lord, Master, owner",
    d: "Lord, Master; title of respect and divine authority; Jesus as Lord.",
    u: "Used 748 times in the NT. 'Thomas said to him: Lord, we do not know where you are going' (John 14:5).",
    e: "From κύριος (kurios) = to have authority"
  },
  "G2992": {
    m: "people",
    d: "A people, a nation; especially God's people (Israel or the Church).",
    u: "Used 142 times in the NT. God's chosen people.",
    e: "Primary root"
  },
  "G3022": {
    m: "white, bright",
    d: "White, brilliant; symbol of purity and victory.",
    u: "Used 25 times in the NT. The white robes of the redeemed.",
    e: "From λευκός (leukos) = white, luminous"
  },
  "G3056": {
    m: "word, speech, reason",
    d: "Spoken word; reason, intelligence; the Logos = Christ.",
    u: "Used 330 times in the NT. The incarnate Logos.",
    e: "From λέγω (lego) = to say"
  },
  "G3101": {
    m: "disciple, learner",
    d: "A learner, student, disciple; follower of Jesus.",
    u: "Used 261 times in the NT. Designates followers of Christ.",
    e: "From μανθάνω (manthano) = to learn"
  },
  "G3141": {
    m: "testimony, witness, evidence",
    d: "Testimony, witness, evidence, proof. Testimony given to truth, particularly to Christ.",
    u: "Used 37 times in the NT. Major theme of John's Gospel.",
    e: "From μάρτυς (martus) = witness"
  },
  "G3173": {
    m: "great, large",
    d: "Great in size, quantity, or importance; mighty, wonderful.",
    u: "Used 243 times in the NT. The greatness of God.",
    e: "Primary root"
  },
  "G3320": {
    m: "dividing wall",
    d: "Middle wall, partition wall.",
    u: "Used 1 time in the NT (Eph 2:14). The wall between Jews and Gentiles.",
    e: "From μέσος (mesos) = middle + τοῖχος (toichos) = wall"
  },
  "G3439": {
    m: "only, only-begotten",
    d: "Unique of its kind, only-begotten; only son.",
    u: "Used 9 times in the NT. The only-begotten Son of God.",
    e: "From μόνος (monos) = alone + γίνομαι (ginomai) = to become"
  },
  "G3474": {
    m: "foolishness, folly",
    d: "Foolishness, absurdity; that which lacks wisdom.",
    u: "Used 5 times in the NT. God's wisdom appears foolish to the world.",
    e: "From μωρός (moros) = foolish, stupid"
  },
  "G3475": {
    m: "Moses",
    d: "Moses, the lawgiver of Israel.",
    u: "Used 80 times in the NT. The law of Moses.",
    e: "From Hebrew מֹשֶׁה (Mosheh) = drawn out (from water)"
  },
  "G3530": {
    m: "Nicodemus",
    d: "Nicodemus, proper name. Pharisee and Jewish ruler who came to Jesus by night. Greek name meaning 'victory of the people'.",
    u: "Used 5 times in the NT. Important character in John's Gospel.",
    e: "From Greek νίκη (nikē) = victory and δῆμος (dēmos) = people"
  },
  "G3551": {
    m: "law, Torah",
    d: "Law, Torah, rule, principle. The law of Moses, divine law, God's commandments.",
    u: "Used 194 times in the NT. Central concept of divine revelation.",
    e: "From νέμω (nemo) = to distribute, give; law given"
  },
  "G3571": {
    m: "night",
    d: "Night, period of darkness between sunset and sunrise. Often metaphorical for spiritual ignorance.",
    u: "Used 61 times in the NT. Contrasted with light in Johannine symbolism.",
    e: "Primary feminine noun; night"
  },
  "G3598": {
    m: "way, road",
    d: "Road, way; manner of living, conduct; the way of salvation.",
    u: "Used 101 times in the NT. Jesus is the way.",
    e: "Primary root"
  },
  "G3609": {
    m: "domestic, of the household",
    d: "Belonging to the house, family member; domestic servant.",
    u: "Used 3 times in the NT. Describes members of God's family.",
    e: "From οἶκος (oikos) = house"
  },
  "G3664": {
    m: "like, similar",
    d: "Like, of the same nature or character; equivalent.",
    u: "Used 45 times in the NT. The second commandment like the first.",
    e: "From ὁμός (homos) = same"
  },
  "G3686": {
    m: "name",
    d: "Name, title; reputation; authority, power.",
    u: "Used 228 times in the NT. The name of Jesus.",
    e: "Primary root"
  },
  "G3708": {
    m: "to see, look at",
    d: "To see with the eyes; to perceive, understand; to appear.",
    u: "Used 454 times in the NT. To see Christ, to see the Father.",
    e: "Primary root"
  },
  "G3735": {
    m: "mountain, hill",
    d: "Mountain, mount; elevated hill.",
    u: "Used 63 times in the NT. The mount of transfiguration.",
    e: "Probably from ὁράω (horao) = to see"
  },
  "G3756": {
    m: "not, no",
    d: "Absolute negation, no, not.",
    u: "Used over 1600 times in the NT. Very frequent negative particle.",
    e: "Primary negative particle"
  },
  "G3762": {
    m: "no one, nothing, none",
    d: "No one, nothing, none, not any. Absolute negation of existence or quantity.",
    u: "Used 234 times in the NT. Strong negation very common.",
    e: "From οὐδέ (oude) and εἷς (heis); not even one"
  },
  "G3778": {
    m: "this, these, this one",
    d: "Demonstrative pronoun: this, these, this one. Designates something near or previously mentioned.",
    u: "Used 1388 times in the NT. Most frequent demonstrative pronoun.",
    e: "Primary demonstrative pronoun"
  },
  "G3789": {
    m: "serpent",
    d: "Serpent, reptile; the ancient serpent (Satan).",
    u: "Used 14 times in the NT. The bronze serpent in the wilderness.",
    e: "Primary root"
  },
  "G3793": {
    m: "crowd, multitude",
    d: "Crowd of people, multitude; the popular mass.",
    u: "Used 175 times in the NT. The crowds that followed Jesus.",
    e: "From ὄχος (ochos) = vehicle (that carries)"
  },
  "G3880": {
    m: "receive, take, accept",
    d: "To receive, take, accept, seize. To receive something that is offered or given.",
    u: "Used 59 times in the NT. Central concept of accepting the Gospel.",
    e: "From παρά (para) = beside and λαμβάνω (lambanō) = to take"
  },
  "G3956": {
    m: "all, every",
    d: "All, every, each; the whole, the totality.",
    u: "Used 1244 times in the NT. Among the most frequent words.",
    e: "Primary root"
  },
  "G3962": {
    m: "father",
    d: "A natural or spiritual father; ancestor; God the Father.",
    u: "Used 413 times in the NT. Often to designate God.",
    e: "Primary root related to Latin 'pater'"
  },
  "G4100": {
    m: "to believe, have faith",
    d: "To have faith in, believe; to trust in, rely on.",
    u: "Used 241 times in the NT. To believe in Jesus to be saved.",
    e: "From πίστις (pistis) = faith"
  },
  "G4102": {
    m: "faith, trust, faithfulness",
    d: "Conviction of the truth of anything, belief; in the NT of a conviction concerning man's relationship with God and divine things.",
    u: "Used 244 times in the NT. Central concept of Christian faith.",
    e: "From πείθω (peitho) = to persuade, convince"
  },
  "G4138": {
    m: "fullness, abundance, that which fills",
    d: "Fullness, abundance, that which fills completely. The totality, divine completeness.",
    u: "Used 17 times in the NT. Theological concept of divine fullness in Christ.",
    e: "From πλήρης (plērēs) = full; fullness"
  },
  "G4139": {
    m: "neighbor",
    d: "One who is near, the neighbor; neighbor in general.",
    u: "Used 17 times in the NT. 'Love your neighbor as yourself'.",
    e: "Adverb become noun, from πλησίος (plesios) = near"
  },
  "G4151": {
    m: "spirit, breath, wind",
    d: "The breath of life, vital principle; the rational soul; the Holy Spirit.",
    u: "Used 385 times in the NT. Designates the Holy Spirit, human spirit, or spirits.",
    e: "From πνέω (pneo) = to blow, breathe"
  },
  "G4160": {
    m: "to do, make, accomplish",
    d: "To do, make, produce, act, create. General action verb covering all types of activity.",
    u: "Used 568 times in the NT. Fundamental action verb, often in God's works.",
    e: "Primary verb; to do, accomplish"
  },
  "G4166": {
    m: "shepherd, pastor",
    d: "One who keeps sheep; spiritual guardian, church pastor.",
    u: "Used 18 times in the NT. Jesus the good shepherd.",
    e: "From ποίμνη (poimne) = flock"
  },
  "G4183": {
    m: "many, much, great",
    d: "Many, much, great in quantity or number. Multitude, large amount.",
    u: "Used 416 times in the NT. Very frequent quantitative adjective.",
    e: "Uncertain root; many, much"
  },
  "G4198": {
    m: "go, walk, travel",
    d: "To go, walk, travel, move. Movement from one place to another, often with purpose.",
    u: "Used 154 times in the NT. Fundamental movement verb in Gospel narratives.",
    e: "Primary verb; to go, walk"
  },
  "G4238": {
    m: "do, practice, accomplish",
    d: "To do, practice, accomplish, act. To perform actions, often with idea of repetition or habit.",
    u: "Used 39 times in the NT. Often linked to practice of good or evil.",
    e: "Strengthened form of πράω (praō); to do, practice"
  },
  "G4263": {
    m: "sheep",
    d: "Sheep or lamb; metaphorically, disciples of Christ.",
    u: "Used 39 times in the NT. Believers as sheep of the shepherd.",
    e: "Probably related to προβαίνω (probaino) = to advance"
  },
  "G4413": {
    m: "first, chief",
    d: "First in time, place, order, or importance.",
    u: "Used 155 times in the NT. The first commandment, first place.",
    e: "Superlative of πρό (pro) = before"
  },
  "G4561": {
    m: "flesh, body",
    d: "Flesh, meat; the human body; fallen human nature.",
    u: "Used 147 times in the NT. Contrast between flesh and spirit.",
    e: "Primary root"
  },
  "G4592": {
    m: "sign, miracle, wonder",
    d: "Sign, miracle, wonder; supernatural manifestation revealing divine power.",
    u: "Used 77 times in the NT. 'for no one can do these signs that you do' (John 3:2).",
    e: "From σημεῖον (semeion) = mark, sign"
  },
  "G4648": {
    m: "to look carefully, aim at",
    d: "To fix one's eyes upon, consider attentively; to have in view, aim at a goal.",
    u: "Used 6 times in the NT. Call to fix eyes on Christ.",
    e: "Related to σκοπός (skopos) = target, goal"
  },
  "G4680": {
    m: "wise, learned",
    d: "Wise, intelligent, skillful; trained, instructed.",
    u: "Used 22 times in the NT. True wisdom comes from God.",
    e: "Primary root"
  },
  "G4982": {
    m: "to save, deliver",
    d: "To save from danger or destruction; to deliver from sin.",
    u: "Used 106 times in the NT. Jesus saves sinners.",
    e: "From σῶς (sos) = safe and sound"
  },
  "G5040": {
    m: "little child",
    d: "Little child, infant; affectionate term for disciple.",
    u: "Used 8 times in the NT. John calls his readers 'little children'.",
    e: "Diminutive of τέκνον (teknon) = child"
  },
  "G5087": {
    m: "to place, put, establish",
    d: "To put, place; to establish, appoint; to lay down, deposit.",
    u: "Used 100 times in the NT. To lay down one's life for the sheep.",
    e: "Primary root"
  },
  "G5109": {
    m: "wall",
    d: "Separating wall, partition.",
    u: "Used 1 time in the NT (Acts 23:3).",
    e: "Primary root"
  },
  "G5207": {
    m: "son",
    d: "Male descendant; disciple; member of a group. The Son of God = Jesus Christ.",
    u: "Used 377 times in the NT. Often to designate Jesus as Son of God.",
    e: "Uncertain origin, possibly related to ὕω (huo) = to rain, beget"
  },
  "G5281": {
    m: "patience, endurance, perseverance",
    d: "Quality of one who does not succumb to circumstances or pressures; patient endurance, steadfastness.",
    u: "Used 32 times in the NT. Essential Christian virtue.",
    e: "From ὑπό (hupo) = under and μένω (meno) = to remain"
  },
  "G5312": {
    m: "to lift up, exalt",
    d: "To lift high, elevate; to exalt, honor.",
    u: "Used 20 times in the NT. The Son of Man lifted up.",
    e: "From ὕψος (hupsos) = height"
  },
  "G5376": {
    m: "Philip",
    d: "Philip, proper name. One of the twelve apostles. Greek name meaning 'lover of horses'.",
    u: "Used 36 times in the NT. Name of the apostle and deacon.",
    e: "From Greek φίλος (philos) = friend and ἵππος (hippos) = horse"
  },
  "G5432": {
    m: "to guard, protect",
    d: "To guard with a military guard; to protect, preserve.",
    u: "Used 4 times in the NT. The peace of God guards our hearts.",
    e: "From φρουρός (phrouros) = guard, sentinel"
  },
  "G5443": {
    m: "tribe, people",
    d: "Tribe, clan; a people descended from a common ancestor.",
    u: "Used 31 times in the NT. The twelve tribes of Israel.",
    e: "From φύω (phuo) = to produce, grow"
  },
  "G5457": {
    m: "light",
    d: "Physical or spiritual light; divine truth revealed.",
    u: "Used 73 times in the NT. Jesus light of the world.",
    e: "From φάω (phao) = to shine"
  },
  "G5463": {
    m: "to rejoice, be glad",
    d: "To rejoice, be happy; greeting 'rejoice' or 'hail'.",
    u: "Used 74 times in the NT. Frequent command to rejoice in Christ.",
    e: "Related to χάρις (charis) = grace"
  },
  "G5495": {
    m: "hand",
    d: "The hand; power, authority; action, work.",
    u: "Used 177 times in the NT. The hand of God, the hands of Jesus.",
    e: "Primary root"
  },
  "G5544": {
    m: "goodness, kindness",
    d: "Goodness in action, practical benevolence; quality of one who is useful, profitable to others.",
    u: "Used 10 times in the NT. Fruit of the Spirit according to Galatians 5:22.",
    e: "From χρηστός (chrestos) = good, useful, kind"
  },
  "G5547": {
    m: "Christ, Messiah, Anointed",
    d: "The Anointed One, the Messiah; title of Jesus as promised Savior.",
    u: "Used 529 times in the NT. Jesus is the Christ.",
    e: "From χρίω (chrio) = to anoint"
  },
  "G5590": {
    m: "soul, life",
    d: "The breath of life, vital soul; life itself; the immortal soul.",
    u: "Used 105 times in the NT. Spiritual and eternal life.",
    e: "From ψύχω (psucho) = to breathe, cool"
  },
  "H120": {
    m: "man, humanity, Adam",
    d: "Man, human being; humanity; Adam the first man.",
    u: "Used 562 times in the OT. God created man.",
    e: "From אָדֹם (adom) = red, or אֲדָמָה (adamah) = ground"
  },
  "H160": {
    m: "love, affection",
    d: "Love, affection; act of love.",
    u: "Used 40 times in the OT. God's love for His people.",
    e: "From אָהַב (ahab) = to love"
  },
  "H216": {
    m: "light",
    d: "Natural or spiritual light; happiness, prosperity.",
    u: "Used 120 times in the OT. 'Let there be light!'",
    e: "From אוֹר (or) = to be luminous"
  },
  "H430": {
    m: "God, gods",
    d: "The supreme God (Elohim); sometimes used for judges or pagan gods.",
    u: "Used 2606 times in the OT. Plural of majesty name for God.",
    e: "Plural of אֱלוֹהַּ (eloah) = god"
  },
  "H559": {
    m: "to say, speak",
    d: "To say, speak, declare; to command, think.",
    u: "Used 5316 times in the OT. The most frequent speech verb.",
    e: "Primary root"
  },
  "H776": {
    m: "earth, land",
    d: "Earth, ground; land, region; the terrestrial world.",
    u: "Used 2504 times in the OT. The earth that God created.",
    e: "Primary root"
  },
  "H982": {
    m: "to trust, have confidence",
    d: "To trust in, have confidence; to be secure.",
    u: "Used 120 times in the OT. Trust in the LORD.",
    e: "Primary root"
  },
  "H1004": {
    m: "house, dwelling",
    d: "House, habitation; family, household; temple.",
    u: "Used 2055 times in the OT. The house of the LORD.",
    e: "From בָּנָה (banah) = to build"
  },
  "H1254": {
    m: "to create",
    d: "To create from nothing; to form, make; exclusive activity of God.",
    u: "Used 54 times in the OT. God created the heavens and the earth.",
    e: "Primary root"
  },
  "H1516": {
    m: "valley, ravine",
    d: "Valley, gorge, ravine; plain.",
    u: "Used 60 times in the OT. The valley of the shadow of death.",
    e: "Primary root"
  },
  "H1878": {
    m: "to make fat, anoint",
    d: "To make fat, fatten; to prosper.",
    u: "Used 11 times in the OT. You anoint my head with oil.",
    e: "From דֶּשֶׁן (deshen) = fat, ashes"
  },
  "H1980": {
    m: "to walk, go",
    d: "To walk, go, come; to live, conduct oneself.",
    u: "Used 1554 times in the OT. Very frequent motion verb.",
    e: "Primary root"
  },
  "H2617": {
    m: "goodness, mercy, faithfulness",
    d: "Goodness, mercy; covenant faithfulness; loyal love.",
    u: "Used 248 times in the OT. The goodness of the LORD.",
    e: "From חָסַד (chasad) = to be good, merciful"
  },
  "H2637": {
    m: "to lack, be in need",
    d: "To lack, be in need; to diminish, be wanting.",
    u: "Used 23 times in the OT. I shall not want (Ps 23:1).",
    e: "Primary root"
  },
  "H2896": {
    m: "good, well",
    d: "Good, pleasant, excellent; kind, right.",
    u: "Used 559 times in the OT. God saw that it was good.",
    e: "Primary root"
  },
  "H3068": {
    m: "YHWH, the LORD",
    d: "The proper name of God, sacred tetragrammaton YHWH.",
    u: "Used 6828 times in the OT. The most holy name.",
    e: "From הָיָה (hayah) = to be, exist"
  },
  "H3117": {
    m: "day",
    d: "Day (opposite of night); 24-hour period; era, time.",
    u: "Used 2301 times in the OT. The day that the LORD has made.",
    e: "From יוֹם (yowm) = to be hot"
  },
  "H3372": {
    m: "to fear, be afraid, revere",
    d: "To fear, be afraid; to revere, respect God.",
    u: "Used 335 times in the OT. I will fear no evil.",
    e: "Primary root"
  },
  "H3563": {
    m: "cup, chalice",
    d: "Cup, chalice; portion, lot.",
    u: "Used 31 times in the OT. My cup overflows.",
    e: "Primary root"
  },
  "H3820": {
    m: "heart, mind",
    d: "Heart, seat of emotions; mind, intelligence, will.",
    u: "Used 598 times in the OT. The heart of man.",
    e: "Primary root"
  },
  "H3915": {
    m: "night",
    d: "Night (opposite of day); time of darkness.",
    u: "Used 234 times in the OT. God separated day and night.",
    e: "Primary root"
  },
  "H3966": {
    m: "very, exceedingly",
    d: "Very, exceedingly, much; with force, quickly.",
    u: "Used 300 times in the OT. It was very good.",
    e: "From מָאַד (ma'ad) = to be numerous"
  },
  "H4325": {
    m: "water, waters",
    d: "Water, waters; rain; flood, sea.",
    u: "Used 585 times in the OT. The waters of creation.",
    e: "Dual of מַיִם (mayim) = water"
  },
  "H4999": {
    m: "pasture, dwelling",
    d: "Pasture place, meadow; habitation, dwelling.",
    u: "Used 13 times in the OT. In green pastures.",
    e: "From נָאָה (na'ah) = to be beautiful, suitable"
  },
  "H5148": {
    m: "to lead, guide",
    d: "To lead, guide, direct; to lead safely.",
    u: "Used 40 times in the OT. He leads me (Ps 23:3).",
    e: "Primary root"
  },
  "H5216": {
    m: "pasture, cultivated land",
    d: "Meadow, pasture; cultivated land, field.",
    u: "Used 2 times in the OT. Green pastures.",
    e: "From נִיר (niyr) = to plow"
  },
  "H5315": {
    m: "soul, life, person",
    d: "Soul, life, living being; person, self; desire, appetite.",
    u: "Used 753 times in the OT. My soul, my life.",
    e: "From נָפַשׁ (naphash) = to breathe"
  },
  "H5769": {
    m: "eternity, forever",
    d: "Indefinite time, eternity; forever, perpetuity.",
    u: "Used 439 times in the OT. God's eternal love.",
    e: "From עָלַם (alam) = to hide, be hidden"
  },
  "H6186": {
    m: "to arrange, set in order",
    d: "To arrange in order, set; to prepare a table.",
    u: "Used 75 times in the OT. You prepare a table (Ps 23:5).",
    e: "Primary root"
  },
  "H6213": {
    m: "to do, make",
    d: "To do, make, accomplish; to act, work.",
    u: "Used 2632 times in the OT. Very frequent verb.",
    e: "Primary root"
  },
  "H6664": {
    m: "righteousness, justice",
    d: "Righteousness, rightness, equity; faithfulness.",
    u: "Used 119 times in the OT. Paths of righteousness.",
    e: "From צָדַק (tsadaq) = to be righteous"
  },
  "H6754": {
    m: "image, likeness",
    d: "Image, likeness; form, appearance.",
    u: "Used 17 times in the OT. Man created in God's image.",
    e: "From צָלַל (tsalal) = to shade, resemble"
  },
  "H6757": {
    m: "shadow of death, deep darkness",
    d: "Deep darkness, deadly darkness; shadow of death.",
    u: "Used 18 times in the OT. Symbolizes extreme danger.",
    e: "From צֵל (tsel) = shadow + מָוֶת (maveth) = death"
  },
  "H6887": {
    m: "to be in distress, adversary",
    d: "To be tight, in distress; adversary, enemy.",
    u: "Used 58 times in the OT. In the presence of my enemies.",
    e: "Primary root"
  },
  "H7121": {
    m: "to call, cry out, proclaim",
    d: "To call, cry; to name; to proclaim, summon.",
    u: "Used 736 times in the OT. To call on the name of the LORD.",
    e: "Primary root"
  },
  "H7200": {
    m: "to see, look at",
    d: "To see with the eyes; to perceive, understand; to provide.",
    u: "Used 1311 times in the OT. God saw that it was good.",
    e: "Primary root"
  },
  "H7225": {
    m: "beginning, firstfruits",
    d: "Beginning, start; the best, the firstfruits.",
    u: "Used 51 times in the OT. 'In the beginning God created...'",
    e: "From רֹאשׁ (rosh) = head, beginning"
  },
  "H7257": {
    m: "to lie down, rest",
    d: "To lie down, rest; to dwell; to brood.",
    u: "Used 30 times in the OT. He makes me lie down (Ps 23:2).",
    e: "Primary root"
  },
  "H7291": {
    m: "to pursue, chase",
    d: "To pursue, chase; to persecute; to follow closely.",
    u: "Used 144 times in the OT. Goodness will follow me.",
    e: "Primary root"
  },
  "H7307": {
    m: "spirit, breath, wind",
    d: "Breath, wind; spirit of God or man; mental disposition.",
    u: "Used 378 times in the OT. The Spirit of God.",
    e: "From רוּחַ (ruach) = to blow"
  },
  "H7462": {
    m: "to shepherd, feed, pasture",
    d: "To pasture a flock; to be a shepherd; to feed, care for.",
    u: "Used 173 times in the OT. The LORD is my shepherd.",
    e: "Primary root"
  },
  "H7549": {
    m: "expanse, firmament",
    d: "Expanse, celestial vault, firmament; the sky.",
    u: "Used 17 times in the OT. The expanse in the midst of the waters.",
    e: "From רָקַע (raqa) = to spread out, beat"
  },
  "H7626": {
    m: "rod, tribe",
    d: "Rod, staff; tribe, family branch.",
    u: "Used 190 times in the OT. Your rod and Your staff.",
    e: "From שָׁבַט (shabat) = to branch"
  },
  "H7725": {
    m: "to return, restore",
    d: "To return, come back; to restore, renew; to repent.",
    u: "Used 1058 times in the OT. He restores my soul.",
    e: "Primary root"
  },
  "H7979": {
    m: "table",
    d: "Table for eating; table of showbread.",
    u: "Used 71 times in the OT. The prepared table.",
    e: "From שָׁלַח (shalach) = to send, stretch out"
  },
  "H8064": {
    m: "heavens, sky",
    d: "Heavens, firmament; dwelling of God; visible sky.",
    u: "Used 420 times in the OT. The heavens and the earth.",
    e: "Dual of שָׁמַיִם (shamayim) = heights"
  },
  "H8414": {
    m: "formless, empty, chaos",
    d: "Wilderness, desolation; chaos, emptiness, void.",
    u: "Used 20 times in the OT. The earth was formless and empty.",
    e: "From תָּהָה (tahah) = to wander"
  }
};

export default strongTranslationsEN;
